import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CaptacionComercialRoutingModule } from './captacion-comercial-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { TendenciaComponent } from './tendencia/tendencia.component';
import { PerfilComponent } from './perfil/perfil.component';
import { MetasComponent } from './metas/metas.component';


@NgModule({
  declarations: [
    TendenciaComponent,
    PerfilComponent,
    MetasComponent
  ],
  imports: [
    CommonModule,
    CaptacionComercialRoutingModule,
    SharedModule
  ]
})
export class CaptacionComercialModule { }
